import { render, staticRenderFns } from "./RepairModal.vue?vue&type=template&id=6f0d5a79"
import script from "./RepairModal.vue?vue&type=script&lang=js"
export * from "./RepairModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports